import { useSyncExternalStore } from 'react';

// Touch devices keep the compact UI even in landscape/tablet viewports.
const DESKTOP_VIEWER_QUERY = '(min-width: 768px) and (hover: hover) and (pointer: fine)';
const subscribe = (onChange: () => void) => {
  const media = window.matchMedia(DESKTOP_VIEWER_QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};
const getSnapshot = () => window.matchMedia(DESKTOP_VIEWER_QUERY).matches;

export const useDesktopViewer = () => useSyncExternalStore(subscribe, getSnapshot, () => false);
